var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"lazy-image",class:{'lazy-image--deferred': (_vm.defer && !_vm.loaded)},attrs:{"loading":_vm.loaded ? 'eager' : 'lazy',"src":_vm.source},on:{"error":_vm.handleError}})
}
var staticRenderFns = []

export { render, staticRenderFns }